import { render, staticRenderFns } from "./NavUserVideoCard.vue?vue&type=template&id=37582e0a&scoped=true&"
import script from "./NavUserVideoCard.vue?vue&type=script&lang=js&"
export * from "./NavUserVideoCard.vue?vue&type=script&lang=js&"
import style0 from "./NavUserVideoCard.vue?vue&type=style&index=0&id=37582e0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37582e0a",
  null
  
)

export default component.exports